import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { DataTable } from '@warrenbrasil/nebraska-web';

import { ISubType } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';
import { columns, IDataTableProps } from './helpers';

interface Props {
  items: ISubType[];
  isApplied: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsTable',
  props: {
    items: null,
    isApplied: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  items: ISubType[];
  isApplied: boolean;
}



const tableData = computed(() => {
  const list: IDataTableProps[] = [];

  props.items?.forEach(item => {
    item.allocations.forEach(allocation => {
      list.push({
        name: allocation?.name,
        subClass: props.isApplied ? item?.name : '-',
        initialDate: allocation?.initialDate?.formatted ?? '-',
        withdrawPeriod: allocation?.withdrawPeriod?.value ?? '-',
        risk: allocation?.risk,
        totalBalance: allocation?.totalBalance?.formatted ?? '-',
        percent: allocation?.percent?.formatted
      });
    });
  });

  return list || [];
});

return { __sfc: true,props, tableData, DataTable, columns }
}

})